import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from './api.service';
import { Ota } from './../models/ota.model';
import { isDefined } from './../translator/util';
import { WindowRefService } from '../window-ref.service';
import {
  min,
  max,
  values,
  has,
  groupBy,
  map as mapLodash,
  chain,
  head,
  size
} from 'lodash';
import { ICombine } from '@app/shared/interfaces';

const routes = {
  comparator: '/comparator'
};

@Injectable({
  providedIn: 'root'
})
export class ComparatorsService {
  public otas: any = {};
  private errors: any = {};
  constructor(
    private apiService: ApiService,
    private winRef: WindowRefService
  ) { }

  /**
   * get ota
   * @param {string} engine engine b,e,a...
   * @param {string} start date start Y-m-d
   * @param {string} end date start Y-m-d
   * @param {string} adults nb adults ex: 2
   * @param {string} currency currency
   * @param {string} tokenSearch tokenSearch
   * @param {string} utmSource is from google hotel finder
   * @returns Observable<Ota>
   */
  getOta(
    engine: string,
    start: string,
    idetab: number,
    end: string,
    adults: number,
    enfants: number,
    agesEnfants: Array<any>,
    currency: string,
    tokenSearch: string,
    utmSource: string
  ): Observable<Ota> {
    let params = new HttpParams({
      fromObject: {
        engine: engine,
        adults: adults.toString(),
        enfants: enfants.toString(),
        curency: currency,
        start: start,
        idetab: idetab.toString(),
        end: end,
        nbRooms: '1',
        tokenSearch: tokenSearch,
        hi: this.winRef.appConfigSite.hi ? '1' : '0',
        utmSource: utmSource
      }
    });
    agesEnfants.forEach(v => {
      params = params.append('agesEnfants[]', v);
    });
    let ob = this.apiService.get(routes.comparator, params);
    return ob.pipe(
      map(response => {
        if (
          isDefined(response[engine]) &&
          isDefined(response[engine]['engine'])
        ) {
          let ota = new Ota(response[engine], engine)
          this.otas[engine] = ota
          return this.otas[engine];
        }
        if (
          isDefined(response['response']) &&
          isDefined(response['response']['errors'])
        ) {
          this.errors[engine] =
            size(response['response']['errors']) > 0
              ? head(response['response']['errors'])
              : {};
        }
        return null;
      })
    );
  }

  /**
   * get Ota
   * @param {string} engine engine b,e,a...
   * @returns Ota|undefined
   */
  public getDataOta(engine: string): Ota {
    return this.otas[engine];
  }

  public getStockRoomByOta(idRoom: number) {
    let results = {};
    mapLodash(this.otas, (ota: Ota, alias: string) => {
      let result = chain(ota.engine)
        .filter({ code_room: idRoom })
        .groupBy('code_room')
        .mapValues(values =>
          chain(values)
            .groupBy((el: ICombine) => {
              let infos = el.indexSearch.split('_');
              return [infos[1]];
            })
            .mapValues(values =>
              chain(values)
                .groupBy(ele => [
                  `"${ele.code_occupancy}_${ele.code_children}"`
                ])
                .value()
            )
            .value()
        )
        .value();
      results[alias] = result;
    });
    return results;
  }

  public getTitleRoomByOta(idRoom: number, alias: string = 'b'): string {
    let results = "", ota = this.getDataRoomByOta(idRoom, alias);
    if (!!ota) {
      //remove Trailing Numbers
      results = ota.roomtype_ota.room_name.replace(/-\d+$/, '');
    }
    return results;
  }

  public getSurfaceRoomByOta(idRoom: number, alias: string = 'b'): string {
    let results = "", ota = this.getDataRoomByOta(idRoom, alias);
    if (!!ota) {
      results = ota.metrage;
    }
    return results;
  }
  private getDataRoomByOta(idRoom: number, alias: string = 'b'): ICombine | null {
    let results: ICombine = null;
    if (has(this.otas, alias)) {
      let result: ICombine = chain(this.otas[alias].engine)
        .find({ code_room: idRoom })
        .value();
      if (!!result) {
        results = result;
      }
    }
    return results;
  }

  public getErrors(engine: string): Array<any> {
    return this.errors[engine];
  }
}
